import { render, staticRenderFns } from "./TableEstimate.vue?vue&type=template&id=2642eb83&scoped=true"
import script from "./TableEstimate.vue?vue&type=script&lang=js"
export * from "./TableEstimate.vue?vue&type=script&lang=js"
import style0 from "./TableEstimate.vue?vue&type=style&index=0&id=2642eb83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642eb83",
  null
  
)

export default component.exports